export class AssignmentSummary {
    ID: number;
    Name: string;
    StartDate: string;
    EndDate: string;
    MinTime: number;
    MaxTime: number;
    ActivityCount: number;
}